import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';
import ReactMarkdown from 'react-markdown';

interface EULAModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const EULAModal: React.FC<EULAModalProps> = ({ isOpen, onClose }) => {
  const [eulaContent, setEulaContent] = useState('');
  const [error, setError] = useState(false);

  useEffect(() => {
    fetch('/legal/EULA.md')
      .then(response => {
        if (!response.ok) {
          throw new Error('Failed to load EULA');
        }
        return response.text();
      })
      .then(text => {
        setEulaContent(text);
        setError(false);
      })
      .catch(error => {
        console.error('Error loading EULA:', error);
        setError(true);
      });
  }, []);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[1001] flex items-center justify-center bg-black/50 backdrop-blur-sm p-4">
      <div className="relative w-full max-w-4xl h-[80vh] mx-auto bg-obsidian-800 rounded-lg shadow-xl">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-white/10">
          <h2 className="text-2xl font-display text-gold-200">
            End User License Agreement
          </h2>
          <button
            onClick={onClose}
            className="text-gold-200/60 hover:text-gold-200 transition-colors"
          >
            <X className="w-6 h-6" />
          </button>
        </div>

        {/* Content */}
        <div className="p-6 overflow-y-auto h-[calc(80vh-88px)]">
          <div className="prose prose-invert prose-gold max-w-none">
            {error ? (
              <p className="text-red-400">Error loading EULA content. Please try again later.</p>
            ) : (
              <ReactMarkdown>{eulaContent}</ReactMarkdown>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
